import { render, staticRenderFns } from "./ConfirmEmailChange.vue?vue&type=template&id=398db2ae&scoped=true&"
import script from "./ConfirmEmailChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailChange.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailChange.vue?vue&type=style&index=0&id=398db2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398db2ae",
  null
  
)

export default component.exports